// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"f68070fa","488":"5a7e136a"}[chunkId] + ".chunk.js";
};